import React, {Component} from "react";
import {Div, List, RichCell, Title} from "@vkontakte/vkui";
import {formatBytes} from "../assets/constants";
import Dexie from "dexie";



class PhotoStorageListOld extends Component {

    constructor(props) {
        super(props);
        this.dbName = "PhotoUploadDB";
        this.storeName = "photos";
        this.state = {
            imageUrl: props.src,
            photos: [],
            storageTotal: '',
            storageUsed: ''
        };
        this.db = new Dexie(this.dbName)
        this.db.version(2).stores({
            [this.storeName]: "++id, &filename, uri, destination, uploaded, &createdAt, uploadedAt, serverUrl"
        })
    }
    componentDidMount() {
        this.fetchPhotos()
        navigator.storage.estimate().then(estimate => {
            this.setState({storageTotal: `Всего доступно: ${formatBytes(estimate.quota * 1)}`,
                storageUsed: `Использовано: ${formatBytes(estimate.usage * 1)}`})
        });
    }

    async fetchPhotos() {
        const photos = await this.db[this.storeName].toArray()
        this.setState({photos: photos.reverse()});

    }

    render() {
        return (
            <Div>
                <h3>Очередь загрузки фотографий</h3>
                <p>{this.state.storageTotal}</p>
                <p>{this.state.storageUsed}</p>
                {this.state.photos.length > 0 ? <List>
                    {this.state.photos.map(photo => (
                        <div>
                            <RichCell subhead={new Date(photo.createdAt).toLocaleString()}

                                      bottom={
                                          <span>{photo.uploaded ? "Загружен" : "Загружается"} {photo.uploadedAt ? new Date(photo.uploadedAt).toLocaleString() : ""}</span>}
                                      key={photo.id}
                            >
                                {photo.filename}
                            </RichCell>
                            <hr/>
                        </div>
                    ))}
                </List> : 'Очередь пуста'}
            </Div>
        );
    }
}




class PhotoStorageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            photos: [],
            storageTotal: "",
            storageUsed: ""
        };
        this.dbName = "PhotoUploadDB";
        this.storeName = "photos";
        this.db = new Dexie(this.dbName)
        this.db.version(2).stores({
            [this.storeName]: "++id, &filename, uri, destination, uploaded, &createdAt, uploadedAt, serverUrl"
        })

    }

    componentDidMount() {
        this.fetchPhotos();
        navigator.storage.estimate().then(estimate => {
            this.setState({
                storageTotal: `Всего доступно: ${estimate.quota} bytes`,
                storageUsed: `Использовано: ${estimate.usage} bytes`
            });
        });
    }

    async fetchPhotos() {
        const photos = await this.db.photos.toArray();
        this.setState({ photos });
    }

    render() {
        return (
            <Div>
                <h3>Очередь загрузки фотографий</h3>
                <p>{this.state.storageTotal}</p>
                <p>{this.state.storageUsed}</p>
                {this.state.photos.length > 0 ? <List>
                    {this.state.photos.map(photo => (
                        <div>
                            <RichCell subhead={new Date(photo.createdAt).toLocaleString()}

                                      bottom={
                                          <span>{photo.uploaded ? "Загружен" : "Загружается"} {photo.uploadedAt ? new Date(photo.uploadedAt).toLocaleString() : ""}</span>}
                                      key={photo.id}
                            >
                                {photo.filename}
                            </RichCell>
                            <hr/>
                        </div>
                    ))}
                </List> : 'Очередь пуста'}
            </Div>
        );
    }
}


export default PhotoStorageList
